export default "__VITE_ASSET__Dw5t3Ge$__"